import Button from "components/Button";
import ConfirmPopUp from "components/Confirm/ConfirmPopUp";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { cancelSubscription } from "redux/asyncApi/paymentApi";

const CancelSubscription = () => {
  const [show, setShow] = useState(false);
  const {
    userAuth: { token },
  } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  const onConfirmHandler = () => {
    dispatch(cancelSubscription({ token })).then(({ payload }) => {
      if (payload?.status) {
        toast.success(payload.message);
        setTimeout(() => window.location.reload(), 1500);
      }
    });
  };

  return (
    <>
      <Button
        title={"Cancel subscription"}
        className={"button--blue mt-3"}
        onClick={() => setShow(true)}
      />
      <ConfirmPopUp
        heading={"confirmation"}
        confirmMsg={"Are you sure you want to cancel your subscription? You will keep access until the end of the current billing period."}
        show={show}
        handleClose={() => setShow(false)}
        onConfirmHandler={onConfirmHandler}
        contentClassName="max-w-md"
        footerClassName="flex flex-col-reverse gap-2 sm:flex-row sm:justify-between sm:gap-0 sm:space-x-2"
      />
    </>
  );
};

export default CancelSubscription;
